<app-form-input
	[parentForm]="parentForm"
	
	[disabled]="disabled"
	[value]="radioButtonValue"
	
	[label]="step2.getspan12"
	[type]="'radio'"
	[rule]="'pattern_29|required'"
	[errorMessage]="{'required' : 'ctr_1083'}"
	[radios]="[
		{
			label: step2.accordCadre,
			value: accordCadreValue
		},
		{
			label: step2.sysQuali,
			value: sysQualiValue
		},
		{
			label: step2.sad,
			value: sadValue
		},
		{
			label: step2.concours,
			value: concoursValue
		},
		{
			label: step2.catalogueElec,
			value: catalogueElecValue
		},
		{
			label: step2.enchereElec,
			value: enchereElecValue
		},
		{
			label: step2.autres,
			value: autresValue
		}
	]"
	[name]="radioButtonCtrlName"
>
</app-form-input>
<!--842-->
